export default __webpack_public_path__ + "img/31462a2e077d2be3b953d5034cdbdac4.png";